import React, {useEffect, useState, useContext} from "react";
import justcastApi from '../../../api/justcast';
import {Context as MenuContext} from '../../../context/MenuContext'
import { PhotoUpload, ArtworkUploadModal, TranscriptUpload } from "../../../components/episode/assets";
import { ListGroup, ListGroupItem, Row, Card, CardBody } from "reactstrap";
import ToastMessage from "../../../components/ToastMessage";

const transcriptTypes = {
  'transcript_json': '.json',
  'transcript_vtt': '.vtt',
  'transcript_srt': '.srt',
}

const Assets = (props) => {
  const {show_id, id} = props.match.params;
  const {setTeamEpisodePageMenus} = useContext(MenuContext);
  const [loading, setLoading] = useState(true);
  const [pageError, setPageError] = useState(false);
  const [artworkModalOpen, setArtworkModalOpen] = useState(false);
  const [imageUploadErrors, setImageUploadErrors] = useState([]);
  const [artworkSrc, setArtworkSrc] = useState("https://placehold.co/150x150")
  const [artworkId, setArtworkId] = useState(null);
  const [toastShow, setToastShow] = useState(false);
  const [toastMessage, setToastMessage] = useState(null);
  const [toastTitle, setToastTitle] = useState(null);
  const [toastTimeoutId, setToastTimeoutId] = useState(null);
  const [transcriptSrtUrl, setTranscriptSrtUrl] = useState(null)
  const [transcriptVttUrl, setTranscriptVttUrl] = useState(null)
  const [transcriptJsonUrl, setTranscriptJsonUrl] = useState(null)
  const [loadingChange, setLoadingChange] = useState(null);

  useEffect(() => {
    setLoading(true);
    setPageError(false);
    setArtworkSrc("https://placehold.co/150x150");
    setArtworkId(null);
    setTranscriptSrtUrl(null);
    setTranscriptVttUrl(null);
    setTranscriptJsonUrl(null);

    justcastApi.get(`/v2/team_podcasts/${show_id}/team_audioposts/${id}`)
    .then((res) => {
      setLoading(false);
      const data = res.data;
      const {artwork_file, artwork_id, transcript_srt, transcript_vtt, transcript_json, show} = data;
      if(transcript_srt) {
        setTranscriptSrtUrl(transcript_srt)
      }
      if(transcript_vtt) {
        setTranscriptVttUrl(transcript_vtt)
      }
      if(transcript_json) {
        setTranscriptJsonUrl(transcript_json)
      }
      if(artwork_file) {
        setArtworkSrc(artwork_file)
        setArtworkId(artwork_id)
      }
      setTeamEpisodePageMenus({
        title: "Assets",
        subtitle: `${show.name} > ${data.name}`,
        currentPageId: "episode",
        currentTabId: "assets",
        showId: show_id,
        episodeId: id,
        landingPageUrl: show.landing_page_url,
        websiteUrl: show.player_page_link,
        rssFeed: show.rss_feed,
        passwordProtected: show.is_password_protected,
        advancedPrivate: show.is_advanced_private_feed,
        isPrivate: show.is_private,
        isPrivateShow: show.is_private_show,
      })
    })
    .catch((err) => {
      setLoading(false)
      setPageError(true);
    })
  }, [show_id, id])

  const handleSetToast = ({title, message}) => {
    setToastShow(true);
    setToastTitle(title)
    setToastMessage(message);

    if(toastTimeoutId) {
      clearTimeout(toastTimeoutId)
    };

    const _timeOutId = setTimeout(() => {
      setToastShow(false);
    }, 2000)

    setToastTimeoutId(_timeOutId)
  }

  const toggleToast = () => {
    setToastShow(!toastShow);
  }

  const toggleArtworkModal = () => {
    setArtworkModalOpen(!artworkModalOpen);
  }

  const setArtworkErrors = (errors) => {
    setImageUploadErrors(errors);
    setArtworkModalOpen(true);
  }

  const uploadArtwork = (file) => {
    setLoadingChange("artwork");
    const formData = new FormData();
    formData.append("name", "name");
    formData.append("type", "artwork");
    formData.append("file", file)

    justcastApi.post(`/v2/team_podcasts/${show_id}/team_audioposts/${id}/artwork`, formData)
    .then((res) => {
      const { file_url, file_id } = res.data;
      if(file_url) {
        setArtworkSrc(file_url)
        setArtworkId(file_id)
      }

      handleSetToast({title: "Episode artwork", message: "Image upload success"})
      setLoadingChange(null)
    })
    .catch((err) => {
      handleSetToast({title: "Episode artwork", message: "Image upload failed"})
      setLoadingChange(null)
    })
  }

  const deleteArtwork = () => {
    setLoadingChange("artwork");
    justcastApi.delete(`/v2/team_podcasts/${show_id}/team_audioposts/${id}/asset_files?file_type=artwork`)
    .then((res) => {
      setArtworkSrc("https://placehold.co/150x150")
      setArtworkId(null);
      handleSetToast({title: "Episode artwork", message: "Image delete success"})
      setLoadingChange(null);
    })
    .catch((err) => {
      console.log(err)
      setLoadingChange(null);
    })
  }

  const uploadTranscript = (file, fileType) => {
    setLoadingChange(fileType);

    const formData = new FormData();
    formData.append("name", "name");
    formData.append("type", fileType);
    formData.append("file", file)
    justcastApi.post(`/v2/team_podcasts/${show_id}/team_audioposts/${id}/asset_files`, formData)
    .then((res) => {
      setLoadingChange(null);
      const { file_url  } = res.data;
      if(file_url) {
        switch (fileType) {
          case 'transcript_json':
            setTranscriptJsonUrl(file_url);
            break;
          case 'transcript_srt':
            setTranscriptSrtUrl(file_url);
            break;
          case 'transcript_vtt':
            setTranscriptVttUrl(file_url);
            break;
          default:
            console.log('cannot find the right file type')
        }
      }

      handleSetToast({title: "Episode transcript", message: "Transcript upload success"})
    })
    .catch((err) => {
      setLoadingChange(null);
      handleSetToast({title: "Episode transcript", message: "Transcript upload failed"})
    })
  }

  const deleteFile = (fileType) => {
    setLoadingChange(fileType);

    justcastApi.delete(`/v2/team_podcasts/${show_id}/team_audioposts/${id}/asset_files?file_type=${fileType}`)
    .then((res) => {

      switch (fileType) {
        case 'transcript_json':
          setTranscriptJsonUrl(null);
          break;
        case 'transcript_srt':
          setTranscriptSrtUrl(null);
          break;
        case 'transcript_vtt':
          setTranscriptVttUrl(null);
          break;
        default:
          console.log('cannot find the right file type')
      }
      setLoadingChange(null);
      handleSetToast({title: "Episode transcript", message: "Transcript delete success"})
    })
    .catch((err) => {
      console.log(err)
      setLoadingChange(null);
    })
  }

  if(loading || pageError) return null;

  return (
    <div className="container-fluid">
      <ToastMessage
        toggle={toggleToast}
        show={toastShow}
        title={toastTitle}
        message={toastMessage}
      />
      <ArtworkUploadModal
        modal={artworkModalOpen}
        toggle={toggleArtworkModal}
        errors={imageUploadErrors}
      />
      <ListGroup>
        <ListGroupItem>
          <PhotoUpload
            src={artworkSrc}
            setArtworkModalOpen={setArtworkErrors}
            uploadFile={uploadArtwork}
            artworkId={artworkId}
            deleteFile={deleteArtwork}
            loading={loadingChange === "artwork"}
          />
        </ListGroupItem>
      </ListGroup>
      <hr className="my-5"/>
      <div>
        <Row className="justify-content-between align-items-center mb-5">
          <div className="col-12 col-md-9 col-xl-7">
            <h2 className="mb-2">Podcasting 2.0 Transcript</h2>
          </div>
          <div className="col-12 col-md-auto">
          <a className="btn btn-warning btn-sm" href="https://podcastindex.org/namespace/1.0#transcript" target="_blank">Learn more</a>
          </div>
        </Row>
        <Card>
          <CardBody>
            <ListGroup className="list-group-flush my-n3">
              <ListGroupItem>
                <TranscriptUpload
                  title="SRT"
                  description="The SRT format was designed for video captions but provides a suitable solution for podcast transcripts."
                  learnMoreHref="https://github.com/Podcastindex-org/podcast-namespace/blob/main/transcripts/transcripts.md#srt"
                  uploadFile={uploadTranscript}
                  fileType="transcript_srt"
                  fileFormat={transcriptTypes["transcript_srt"]}
                  fileHref={transcriptSrtUrl}
                  deleteFile={deleteFile}
                  loading={loadingChange === "transcript_srt"}
                />
              </ListGroupItem>
              <ListGroupItem>
                <TranscriptUpload
                  title="WebVTT"
                  description="Web Video Text Tracks Format (WebVTT) are an alternative to SRT primarily designed for the use in HTML on the web."
                  learnMoreHref="https://github.com/Podcastindex-org/podcast-namespace/blob/main/transcripts/transcripts.md#webvtt"
                  uploadFile={uploadTranscript}
                  fileType="transcript_vtt"
                  fileFormat={transcriptTypes["transcript_vtt"]}
                  fileHref={transcriptVttUrl}
                  deleteFile={deleteFile}
                  loading={loadingChange === "transcript_vtt"}
                />
              </ListGroupItem>
              <ListGroupItem>
                <TranscriptUpload
                  title="JSON"
                  description="The JSON representation is a flexible format that accomodates various degrees of fidelity in a concise way."
                  learnMoreHref="https://github.com/Podcastindex-org/podcast-namespace/blob/main/transcripts/transcripts.md#json"
                  uploadFile={uploadTranscript}
                  fileType="transcript_json"
                  fileFormat={transcriptTypes["transcript_json"]}
                  fileHref={transcriptJsonUrl}
                  deleteFile={deleteFile}
                  loading={loadingChange === "transcript_json"}
                />
              </ListGroupItem>
            </ListGroup>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default Assets
